<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button *ngIf="!editMode" class="btnback btn btn-outline-success" type="button" (click)="onBack(0)" title="Volver al buscador de Uds. de Inspección">
            <i class="fa fa-chevron-left"></i></button>
        <button *ngIf="editMode" class="btnback btn btn-outline-success" type="button" (click)="onBack(unidadInspeccion?.IdUi)" title="Volver al detalle de la Ud. de Inspección">
            <i class="fa fa-chevron-left"></i></button>
        <button *ngIf="editMode && allowSaving || !editMode && allowCreating" [disabled]="disableSavingButton" class="btn btn-outline-success" type="button" (click)="onClickSave()" title="{{ titleButtonSave }}">
            <i class="fa fa-save"></i> {{ titleButtonSave }}
        </button>
        <button *ngIf="visibilitySpinnerSave" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>
    </form>
</nav>

<div class="container-fluid container-list">

    <ng-container *ngIf="periodoForUi">
        <ng-container *ngIf="periodoForUi?.TamanioMaximoAgrupacion">
            <app-selector-unidad-inspeccion-superficie [superficieUI]="periodoForUi?.SuperficieMax" [superficieAcumulada]="totalHectareasAcumuladas"></app-selector-unidad-inspeccion-superficie>
        </ng-container>
        <!-- Con editMode controlamos si mostrar o no los inputs que permiten realizar la búsqueda en modo creación.
            En modo edición, ya no es necesario buscar por éstos inputs principales, así que los ocultamos. -->
        <ng-container *ngIf="editMode && unidadInspeccion?.FirstRecinto">
            <app-unidad-inspeccion-list *ngIf="unidadInspeccion"
            [userData]="userData" [idTipoSolicitudCam]="idTipoSolicitudCam"
            [readonly]="true" [title]="title" [result]="recintoUnidadInspeccionList" 
            (view)="onView($event)" (delete)="onDelete($event)" ></app-unidad-inspeccion-list>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="formGroup">
        <app-selector-unidad-inspeccion-filter 
            [editMode]="editMode" [formGroup]="formGroup" [unidadInspeccion]="unidadInspeccion"
            [lastFilter]="payload" [campanias]="campanias"
            [periodos]="periodos" [CAs]="CAs" [tiposSolicitud]="tiposSolicitudPI" [EAs]="EAs" [operadores]="operadores"
            [provincias]="provincias" [municipios]="municipios"
            (search)="onSearch($event)" (cleanForm)="onReset()" (campaniaSelected)="onCampaniaSelected($event)" (tipoSolicitudSelected)="getOperadores($event)"
            (periodoSelected)="onPeriodoSelected($event)" (caSelected)="onCASelected($event)" (provinciaSelected)="onProvinciaSelected($event)">
        </app-selector-unidad-inspeccion-filter>
    </ng-container>
        
    <app-selector-unidad-inspeccion-list *ngIf="searching" 
        [result]="result" [lastFilter]="payload" [userData]="userData" [title]="title"
        (selectedRecintosUI)="onSelectedRecintosUI($event)"
        (search)="onSearchLazy($event)" (view)="onView($event)">
    </app-selector-unidad-inspeccion-list>

</div>

<!-- Ventana para mostrar el detalle de un recinto PI y sus cultivos -->
<app-recinto-detail-dialog [visible]="recintoDetailVisible" [Id]="IdRecintoSelected" [editMode]="false" (closed)="onRecintoDialogClosed($event)"></app-recinto-detail-dialog>